import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { action } from 'mobx';
import { propertyDecorator } from 'decorating';
import { setterName, isFunction, isString, isDefined } from '../utils';
export default propertyDecorator(function (target, prop, desc, name, customValue) {
  if (!isString(name)) {
    customValue = name;
    name = undefined;
  }

  name = name || setterName(prop);
  var fnDesc = action.bound(target, name, {
    value: function value(_value) {
      if (isDefined(customValue)) {
        _value = isFunction(customValue) ? customValue.call(this, _value) : customValue;
      }

      this[prop] = _value;
    }
  });
  Object.defineProperty(target, name, fnDesc);
  return desc && _objectSpread({}, desc, {
    configurable: true
  });
});